'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultStyles = undefined;

var _templateObject = _taggedTemplateLiteral([''], ['']);

exports.ContentBannerComponent = ContentBannerComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bduiStyles = require('@bd/bdui-styles');

var _bduiStyles2 = _interopRequireDefault(_bduiStyles);

var _bdcoreUtilities = require('@bd/bdcore-utilities');

var _bdcoreNamedRoutes = require('@bd/bdcore-named-routes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var defaultStyles = exports.defaultStyles = (0, _bduiStyles.css)(_templateObject);

function ContentBannerComponent(_ref) {
  var body = _ref.body,
      button = _ref.button,
      className = _ref.className,
      heading = _ref.heading,
      media = _ref.media,
      postTitle = _ref.postTitle,
      preTitle = _ref.preTitle,
      subtitle = _ref.subtitle,
      title = _ref.title;

  return _react2.default.createElement(
    'div',
    { className: '' + className },
    _react2.default.createElement(
      'div',
      { className: 'ContentBanner_wrapper' },
      _react2.default.createElement(
        'div',
        { className: 'ContentBanner_inner' },
        heading && _react2.default.createElement(
          'div',
          { className: 'ContentBanner_heading' },
          heading
        ),
        _react2.default.createElement(
          'div',
          { className: 'ContentBanner_result' },
          media && _react2.default.createElement(
            'div',
            { className: 'ContentBanner_resultMedia' },
            media
          ),
          _react2.default.createElement(
            'div',
            { className: 'ContentBanner_resultContent' },
            _react2.default.createElement(
              'h3',
              { className: 'ContentBanner_title' },
              _react2.default.createElement(
                'span',
                { className: 'ContentBanner_preTitle' },
                preTitle
              ),
              title,
              _react2.default.createElement(
                'span',
                { className: 'ContentBanner_postTitle' },
                postTitle
              )
            ),
            _react2.default.createElement(
              'h4',
              { className: 'ContentBanner_subtitle' },
              subtitle
            ),
            _react2.default.createElement('div', { className: 'ContentBanner_body', dangerouslySetInnerHTML: (0, _bdcoreUtilities.SanitizeHtml)(body) }),
            _react2.default.isValidElement(button) && button,
            button && !_react2.default.isValidElement(button) && button.route && _react2.default.createElement(
              _bdcoreNamedRoutes.Link,
              { className: 'ContentBanner_link', name: button.route },
              button.children
            ),
            button && !_react2.default.isValidElement(button) && button.path && _react2.default.createElement(
              'a',
              { className: 'ContentBanner_link', href: button.path },
              button.children
            )
          )
        )
      )
    )
  );
}

ContentBannerComponent.propTypes = {
  /** Passed through SanitizeHtml and set on element using dangerouslySetInnerHTML */
  body: _propTypes2.default.string,
  button: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.shape({
    children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]).isRequired,
    route: _propTypes2.default.string,
    path: _propTypes2.default.string
  })]),
  className: _propTypes2.default.string,
  heading: _propTypes2.default.string,
  /** Can be react element or html */
  media: _propTypes2.default.node,
  postTitle: _propTypes2.default.string,
  preTitle: _propTypes2.default.string,
  subtitle: _propTypes2.default.string,
  title: _propTypes2.default.string
};

ContentBannerComponent.defaultProps = {
  body: undefined,
  button: undefined,
  className: '',
  heading: undefined,
  media: undefined,
  postTitle: undefined,
  preTitle: undefined,
  subtitle: undefined,
  title: undefined
};

exports.default = (0, _bduiStyles2.default)(defaultStyles)(ContentBannerComponent);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-contentbanner/build/ContentBanner.js
// module id = 988
// module chunks = 0